export default __webpack_public_path__ + "static/media/dashboard.bb959937.png";